import React, { Component } from 'react';
import './footer.scss';
import * as img from '../../lib/images';
const footer = (props) => {
    if(props.isMobile) {
        return (
            <div className="w-100 footerBox d-flex flex-wrap">
                <div className="col-12">
                    <p style={{ fontWeight: "bold", fontSize: "1rem", color: "#fff" }}>Recent Posts</p>
                    <p style={{ color: "#fff" }}>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever.Since the 1500s, when an unknown printer.</p>
                </div>
                <div className="col-12 mt-4" >
                    <p style={{ fontWeight: "bold", fontSize: "1rem", color: "#fff" }}>Follow Us</p>
                    <p style={{ color: "#fff",fontWeight:"normal" }}>Since the 1500s, when an unknown printer took a galley of type and scrambled. </p>
                    <div className="w-100 d-flex p-0 mt-4">
                        <img className="pr-4" style={{ height: "21px" }} src={img.FACEBOOK} />
                        <img className="pr-4" style={{ height: "21px" }} src={img.TWITTER} />
                        <img className="pr-4" style={{ height: "21px" }} src={img.INSTAGRAM} />
                        <img className="pr-4" style={{ height: "21px" }} src={img.LINKEDIN} />
                    </div>
                </div>
                <div className="col-12 mt-4" >
                    <p style={{ fontWeight: "bold", fontSize: "1rem", color: "#fff" }}>Contact Us</p>
                    <p className="m-0" style={{ color: "#fff", }}>My Company , 4578 Marmora Road, Glasgow D04 89GR</p>
                    <p className="m-0 py-2" style={{ color: "#fff" }}>Call us now: 0123-456-789 </p>
                    <p className="m-0" style={{ color: "#fff" }}>Email: support@whatever.com</p>
                </div>
            </div>
        )
    }else{
        return (
            <div ref={props.setContactRef} className="w-100 footerBox d-flex">
                <div className="col-4 footerDiv" >
                    <p style={{ fontWeight: "bold", fontSize: "1rem", color: "#fff" }}>Recent Posts</p>
                    <p style={{ color: "#fff" }}>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever.Since the 1500s, when an unknown printer.</p>
                </div>
                <div className="col-4 footerDiv" >
                    <p style={{ fontWeight: "bold", fontSize: "1rem", color: "#fff" }}>Follow Us</p>
                    <p style={{ color: "#fff",fontWeight:"normal" }}>Since the 1500s, when an unknown printer took a galley of type and scrambled. </p>
                    <div className="w-100 d-flex p-0 mt-4">
                        <img className="pr-4" style={{ height: "21px" }} src={img.FACEBOOK} />
                        <img className="pr-4" style={{ height: "21px" }} src={img.TWITTER} />
                        <img className="pr-4" style={{ height: "21px" }} src={img.INSTAGRAM} />
                        <img className="pr-4" style={{ height: "21px" }} src={img.LINKEDIN} />
                    </div>
                </div>
                <div className="col-4 footerDiv" >
                    <p style={{ fontWeight: "bold", fontSize: "1rem", color: "#fff" }}>Contact Us</p>
                    <p className="m-0" style={{ color: "#fff", }}>My Company , 4578 Marmora Road, Glasgow D04 89GR</p>
                    <p className="m-0 py-2" style={{ color: "#fff" }}>Call us now: 0123-456-789 </p>
                    <p className="m-0" style={{ color: "#fff" }}>Email: support@whatever.com</p>
                </div>
            </div>
        )
    }
    
}

export default footer;